document.addEventListener("DOMContentLoaded", function () {
  const COMPANY_ID = "X63L9v";
  const LIST_ID = "SqZECr";
  const REVISION = "2026-07-15";

  const wrapper = document.getElementById("VaultBackInStock");
  if (!wrapper) return;

  const trigger = document.getElementById("VaultBackInStockTrigger");
  const modal = document.getElementById("VaultBackInStockModal");
  const closeButton = document.getElementById("VaultBackInStockClose");
  const form = document.getElementById("VaultBackInStockForm");
  const message = document.getElementById("VaultBackInStockMessage");
  document.body.appendChild(modal);

  function getVariantId() {
    const variantInput = document.querySelector(
      '.ProductForm input[name="id"], .ProductForm select[name="id"]'
    );

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    return wrapper.dataset.variantId;
  }

  function updateButton() {
    const addButton = document.querySelector(".ProductForm__AddToCart");

    const soldOut =
      !addButton ||
      addButton.disabled ||
      addButton.getAttribute("aria-disabled") === "true" ||
      /sold out|unavailable/i.test(addButton.textContent);

    trigger.style.display = soldOut ? "block" : "none";
  }

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = "";
  }

  trigger.addEventListener("click", openModal);
  closeButton.addEventListener("click", closeModal);

  modal.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !modal.hidden) {
      closeModal();
    }
  });

  form.addEventListener("submit", async function (event) {
    event.preventDefault();

    const firstName = document
      .getElementById("VaultBackInStockName")
      .value.trim();

    const lastName = document
      .getElementById("VaultBackInStockSurname")
      .value.trim();

    const email = document
      .getElementById("VaultBackInStockEmail")
      .value.trim();

    const variantId = String(getVariantId() || "").trim();
    const submitButton = form.querySelector('button[type="submit"]');

    if (!firstName || !lastName || !email || !variantId) {
      message.textContent = "Please complete all fields.";
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = "Submitting...";
    message.textContent = "";

    try {
      const backInStockResponse = await fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
          encodeURIComponent(COMPANY_ID),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: REVISION
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email
                    }
                  }
                },
                channels: ["EMAIL"]
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: "$shopify:::$default:::" + variantId
                  }
                }
              }
            }
          })
        }
      );

      if (!backInStockResponse.ok) {
        throw new Error(
          "Back in Stock failed: " +
            backInStockResponse.status +
            " " +
            (await backInStockResponse.text())
        );
      }

      const marketingResponse = await fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" +
          encodeURIComponent(COMPANY_ID),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: REVISION
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                      first_name: firstName,
                      last_name: lastName
                    }
                  }
                },
                custom_source: "Back in Stock request"
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: LIST_ID
                  }
                }
              }
            }
          })
        }
      );

      if (!marketingResponse.ok) {
        throw new Error(
          "Marketing signup failed: " +
            marketingResponse.status +
            " " +
            (await marketingResponse.text())
        );
      }

      form.innerHTML = `
        <div class="VaultBisSuccess">
          <h2>Stock request received</h2>

          <p>
            Thank you. We’ll contact you shortly to confirm the item,
            specification and details needed to secure the product.
          </p>

          <button
            type="button"
            id="VaultBisSuccessClose"
            class="VaultBisSubmit"
          >
            Close
          </button>
        </div>
      `;

      document
        .getElementById("VaultBisSuccessClose")
        .addEventListener("click", closeModal);
    } catch (error) {
      console.error("Vault Back in Stock:", error);
      message.textContent = "Something went wrong. Please try again.";
    } finally {
      if (submitButton && document.body.contains(submitButton)) {
        submitButton.disabled = false;
        submitButton.textContent = "Notify me when available";
      }
    }
  });

  document.addEventListener("change", function (event) {
    if (
      event.target &&
      event.target.matches('[name="id"], .SizeSwatch__Radio')
    ) {
      setTimeout(updateButton, 100);
    }
  });

  updateButton();
});